/**
 * The room left around an outline when the map is fitted to it.
 *
 * A fixed 48 px was right for a full-size map and wrong for the dossier's panel,
 * which is about 130 px high: it left 34 px for the outline, so a building opened
 * at roughly zoom 14 as a speck among its neighbours, with the gold box nowhere
 * near "around the property". Padding is a share of the shorter side instead,
 * capped at the old 48 px, and the old 48 px stands when the box has no size yet.
 */
export function fitPadding(box: { clientWidth: number; clientHeight: number } | null): number {
  const shorter = box ? Math.min(box.clientWidth, box.clientHeight) : 0
  if (!(shorter > 0)) return 48
  return Math.max(8, Math.min(48, Math.floor(shorter * 0.15)))
}
